// @flow
import {useLocation} from 'docs/data';

export const useLocationChangeHandler = () => {
  const {getLinkInfo, pushLocation} = useLocation();

  return (href: string) => {
    const link = getLinkInfo(href);
    if (link.type === 'thirdparty') {
      window.open(href, '_blank');
      return;
    }
    if (link.type === 'docs') {
      pushLocation(href);
      return;
    }
    window.location = href;
  };
};
